<ng-container [ngSwitch]="mode">
  <ng-container *ngSwitchCase="LabelMode.DEFAULT" [ngTemplateOutlet]="default"></ng-container>
  <ng-container *ngSwitchCase="LabelMode.INLINE" [ngTemplateOutlet]="inline"></ng-container>
  <ng-container *ngSwitchCase="LabelMode.NO_LABEL" [ngTemplateOutlet]="input"></ng-container>
</ng-container>

<ng-template #input>
  <div class="input-group datepicker-group">
    <input ngbDatepicker #d="ngbDatepicker" rInputMask="99/99/9999" [type]="clearable? 'search': 'text'" class="form-control" [ngClass]="{ 'is-invalid': isError }" [name]="name" [placeholder]="placeholder | translate" [formControl]="form" [firstDayOfWeek]="7" [minDate]="minPDate" [maxDate]="maxPDate">
    <div class="input-group-append">
      <span class="input-group-text cursor-pointer" (click)="d.toggle()" [ngClass]="{'disabled': form.disabled , 'is-invalid': isError}">
        <span [data-feather]="'calendar'" [size]="16"></span>
      </span>
    </div>
  </div>
  <!-- <div>
    <nz-date-picker name="basicDate" [ngClass]="{'is-invalid': isError}" [formControl]="form" [nzFormat]="format" [nzPlaceHolder]="placeholder | translate" [nzDisabledDate]="disabledDate" [nzShowToday]="showToday"></nz-date-picker>
  </div> -->
  <ng-container [ngTemplateOutlet]="error"></ng-container>
</ng-template>

<ng-template #default>
  <div class="form-group" [ngClass]="classes">
    <label [for]="name">{{ label | translate }}  <ng-container [ngTemplateOutlet]="subLabel"></ng-container></label>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>

<ng-template #inline>
  <div class="form-group form-group-inline" [ngClass]="classes">
    <label [for]="name">{{ label | translate }}  <ng-container [ngTemplateOutlet]="subLabel"></ng-container></label>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>

<ng-template #error>
  <span class="error" *ngIf="isError">{{ errorMessage | translate }}</span>
</ng-template>

<ng-template #subLabel>
  <span class="text-muted" *ngIf="addonLabel != ''"> - {{ addonLabel | translate:{year: currentYear} }}</span>
</ng-template>
